import { FileCode } from "lucide-react"
import type { ReactNode } from "react"
import { twMerge } from "tailwind-merge"
import { FilePathActions } from "./FilePathActions"

interface FilePathBarProps {
    path: string
    workingDir: string
    line?: number | null
    leading?: ReactNode
    trailing?: ReactNode
    compact?: boolean
    className?: string
}

export function FilePathBar({ path, workingDir, line, leading, trailing, compact = false, className }: FilePathBarProps) {
    return (
        <div className={twMerge("flex min-h-12 shrink-0 items-center gap-2 border-b border-border bg-base-200 px-2", className)}>
            {leading}
            <FileCode size={14} className="shrink-0 text-muted" />
            <span className="min-w-0 flex-1 truncate font-mono text-xs text-base-content" title={line ? `${path}:${line}` : path}>
                {path}
                {line ? <span className="text-muted/60">:{line}</span> : null}
            </span>
            {trailing}
            <FilePathActions path={path} workingDir={workingDir} compact={compact} />
        </div>
    )
}
